import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {ProveedorLogin} from '../models/enum/emun-enumeracion';
import {AppPresupuestosService} from './app-presupuestos.service';
import {UsersOnlineComponent} from '../../componentes/util/controles/users-online/users-online.component';
import {ClsCliente} from "../models/cls-cliente";
import {AppComponent} from "../../app.component";
import {PrincipalComponent} from "../../componentes/principal/principal.component";
import {IgcContentPane} from "@infragistics/igniteui-dockmanager";

@Injectable({
  providedIn: 'root'
})
export class AppInfoService {
  public infPpto = inject(AppPresupuestosService);

  private _PROVLOGIN: ProveedorLogin;
  private _TRANSLATE: TranslateService;
  private _ESUSUARIODEMO: boolean;
  private _USUARIOLOGEADO: ClsCliente;
  private _DOCUMENTO: Document;
  private _MOSTRAREXPINSACOPLADO = true;
  private _MOSTRAREXPINSACOPLADOMAESTRO = false;
  private _USERSONLINE: UsersOnlineComponent;
  private _USERSONLINEPARTIDA: UsersOnlineComponent;
  private _USERSONLINECONCEPTO: UsersOnlineComponent;
  private _USERSONLINEMATRIZ: UsersOnlineComponent;
  private _APP: AppComponent;
  private _PRINCIPAL: PrincipalComponent;
  private _PANELACTIVADO: IgcContentPane;
  private _fechaCatalogoMatrices: string | null = null;
  private _countCatalogoAI = 0;
  private _countMatricesAI = 0;


  get PANELACTIVADO(): IgcContentPane {
    return this._PANELACTIVADO;
  }
  set PANELACTIVADO(value: IgcContentPane) {
    this._PANELACTIVADO = value;
  }

  set esUsuarioDemo(value: boolean) {
    this._ESUSUARIODEMO = value;
  }

  get esUsuarioDemo(): boolean {
    return this._ESUSUARIODEMO;
  }

  get provLogin(): ProveedorLogin {
    return this._PROVLOGIN;
  }

  set provLogin(value: ProveedorLogin) {
    this._PROVLOGIN = value;
  }

  set usuarioLogeado(value: ClsCliente) {
    this._USUARIOLOGEADO = value;
  }

  get usuarioLogeado(): ClsCliente {
    return this._USUARIOLOGEADO;
  }

  set translate(value: TranslateService) {
    this._TRANSLATE = value;
  }

  get translate(): TranslateService {
    return this._TRANSLATE;
  }

  set documento(value: Document) {
    this._DOCUMENTO = value;
  }

  get documento(): Document {
    return this._DOCUMENTO;
  }

  set mostrarexpinsacoplado(value: boolean) {
    if (this.infPpto.esPptoMaestro) {
      this._MOSTRAREXPINSACOPLADOMAESTRO = value;
    } else {
      this._MOSTRAREXPINSACOPLADO = value;
    }
  }

  get mostrarexpinsacoplado(): boolean {
    if (this.infPpto.esPptoMaestro) {
      return this._MOSTRAREXPINSACOPLADOMAESTRO;
    } else {
      return this._MOSTRAREXPINSACOPLADO;
    }
  }

  get usuarios() {
    return this._USERSONLINE;
  }

  set usuarios(value: UsersOnlineComponent) {
    this._USERSONLINE = value;
  }

  get usersOnlinePartida() {
    return this._USERSONLINEPARTIDA;
  }

  set usersOnlinePartida(value: UsersOnlineComponent) {
    this._USERSONLINEPARTIDA = value;
  }

  get usersOnlineConcepto() {
    return this._USERSONLINECONCEPTO;
  }

  set usersOnlineConcepto(value: UsersOnlineComponent) {
    this._USERSONLINECONCEPTO = value;
  }

  get usersOnlineMatriz() {
    return this._USERSONLINEMATRIZ;
  }

  set usersOnlineMatriz(value: UsersOnlineComponent) {
    this._USERSONLINEMATRIZ = value;
  }

  set app(value: AppComponent) {
    this._APP = value;
  }

  get app(): AppComponent {
    return this._APP;
  }

  set principal(value: PrincipalComponent) {
    this._PRINCIPAL =  value;
  }
  get principal(): PrincipalComponent {
    return this._PRINCIPAL;
  }

  set fechaCatalogoMatrices(value: string | null) {
    this._fechaCatalogoMatrices = value;
  }

  get fechaCatalogoMatrices(): string | null {
    return this._fechaCatalogoMatrices;
  }

  set countCatalogoAI(value: number) {
    this._countCatalogoAI = value;
  }

  get countCatalogoAI(): number {
    return this._countCatalogoAI;
  }

  set countMatricesAI(value: number) {
    this._countMatricesAI = value;
  }

  get countMatricesAI(): number {
    return this._countMatricesAI;
  }

  public setInfoBusquedaAI(countCatalogo: number, countMatrices: number, fecha: Date | string | null) {
    this._countCatalogoAI = countCatalogo;
    this._countMatricesAI = countMatrices;
    if (fecha == null) {
      this._fechaCatalogoMatrices = null;
      return;
    }
    const d = typeof fecha === 'string' ? new Date(fecha) : fecha;
    this._fechaCatalogoMatrices = isNaN(d.getTime()) ? null : d.toLocaleDateString('es-MX', {day: '2-digit', month: '2-digit', year: 'numeric'});
  }
}
